import { DateTime } from "luxon"

export const getGasDayStart = (tz: string, hour: number): Date => {
  const now = DateTime.now().setZone(tz)
  const currentHour = now.hour

  if (currentHour < hour) {
    return now.startOf("day").minus({ days: 1 }).plus({ hours: hour }).toJSDate()
  } else {
    return now.startOf("day").plus({ hours: hour }).toJSDate()
  }
}
